<template>
	<div>
		<div class="d-flex align-center">
			<v-tabs
				v-model="tabs"
				height="65"
				active-class="mid-primary"
				color="white">
				<v-tab :to="{ name: 'work-attendance' }">
					<v-icon class="me-1"> mdi-calendar-check </v-icon>
					{{ $T('tabs.work') }}
				</v-tab>
				<v-tab :to="{ name: 'vacation-attendance' }">
					<v-icon class="me-1"> mdi-calendar-alert </v-icon>
					{{ $T('tabs.vacation') }}
				</v-tab>
				<v-tab :to="{ name: 'permission-attendance' }">
					<v-icon class="me-1"> mdi-calendar-clock </v-icon>
					{{ $T('tabs.permissions') }}
				</v-tab>
				<v-tab :to="{ name: 'mission-attendance' }">
					<v-icon class="me-1"> mdi-calendar-star </v-icon>
					{{ $T('tabs.mission') }}
				</v-tab>
				<v-divider
					vertical
					class="mx-1"></v-divider>
				<v-tab :to="{ name: 'fingerprints-devices' }">
					<v-icon class="me-1"> mdi-fingerprint </v-icon>
					{{ $T('tabs.fingerprints-devices') }}
				</v-tab>
			</v-tabs>

			<v-divider
				vertical
				class="me-1 ms-auto"></v-divider>
			<div
				style="width: 300px"
				class="text-center primary--text px-3">
				{{ $T(`routes.${this.$route.meta.i18nTranslateKey}`) }}
			</div>
		</div>

		<v-divider></v-divider>

		<router-view></router-view>
	</div>
</template>
<script>
export default {
	name: 'Attendance',

	data() {
		return {
			tabs: null,
		};
	},
};
</script>
